import {select as d3select} from 'd3-selection';
import {format as d3format} from 'd3-format';
import {sum as d3sum} from 'd3-array';
import {scaleLinear} from 'd3-scale';
// import {transition as d3transition} from 'd3-transition';

import * as _ from 'underscore';

import Model from '../Model/Model';
import Dispatch from '../Dispatch/Dispatch';
import State from '../State/State';

import './StackedBar.css';


var container = d3select('.WorldMap-stackedbar');
var numberFormat = d3format(',');
var posScale = scaleLinear().range([0, 500]);
var colorScale = scaleLinear().range(['#111', '#ccc']);
var sorted; // The sorted list of countries

// var transition = d3transition();

var getSeries = () => {
	switch(State.selectedSeries) {
	case 'cases':
		return 'Cases ETEC and Shigella';

	case 'deaths':
		return State.includeIndirectDeaths ? 'Direct and indirect deaths ETEC and Shigella' : 'Direct deaths ETEC and Shigella';

	case 'dalys':
		return State.includeStunting ? 'DALYs direct and stunting ETEC and Shigella' : 'DALYs direct ETEC and Shigella';

	default:
		return '';
	}
}

var getUnit = () => {
	switch(State.selectedSeries) {
	case 'cases':
		return 'Cases';

	case 'deaths':
		return 'Deaths';

	case 'dalys':
		return 'DALYs';

	default:
		return '';
	}
}

function getValue(country) {
	var series = getSeries();
	var countryData = Model.dataLU[country];
	var value = +countryData[series];

	if(State.selectedSeries === 'dalys' && State.dalysByRate) {
		value = 100000 * value / countryData['Population (<5)'];
	}

	return value;
}

function layout(data) {
	// var series = getSeries();
	var ret = [];
	var total = d3sum(data, d => getValue(d.Country));
	posScale.domain([0, total]);

	var cumulative = 0;
	for(let i = 0; i < data.length; i++) {
		var d = data[i];
		var value = getValue(d.Country);
		ret.push({
			Country: d.Country,
			length: posScale(value),
			value: value,
			pos: cumulative
		});
		cumulative += posScale(value);
	}
	return ret;
}

var init = () => {
	Dispatch.dispatch.on('dataReady.StackedBar', update);
	Dispatch.dispatch.on('selectedSeriesUpdate.StackedBar', update);
	Dispatch.dispatch.on('highlightedCountryUpdate.StackedBar', () => {updateHighlight(); updateMarker();});
	Dispatch.dispatch.on('includeIndirectDeathsUpdate.StackedBar', update);
	Dispatch.dispatch.on('includeStuntingUpdate.StackedBar', update);
	Dispatch.dispatch.on('dalysByRateUpdate.StackedBar', update);
};

function updateHighlight() {
	container
		.select('.WorldMap-stackedbar-bars')
		.selectAll('rect')
		.classed('highlighted', d => d.Country === State.highlightedCountry);
}

function updateTotal() {
	// var series = getSeries();	
	// var total = d3sum(Model.data, d => getValue(d.Country));

	var total = d3sum(Model.data, d => {
		var series = getSeries();
		var countryData = Model.dataLU[d.Country];
		return +countryData[series];
	});

	if(State.selectedSeries === 'dalys' && State.dalysByRate) {
		var totalPopulation = d3sum(Model.data, d => {return +d['Population (<5)']})
		total = 100000 * total / totalPopulation;
	}


	container
		.select('.WorldMap-stackedbar-total text')
		.text(numberFormat(Math.round(total)) + ' ' + getUnit().toUpperCase());

	container
		.select('.WorldMap-stackedbar-total-label-bottom text')
		.text(State.selectedSeries === 'dalys' && State.dalysByRate ? 'per 100K children' : '');

}

function updateMarker() {
	var markerContainer = container.select('.WorldMap-stackedbar-marker');

	if(State.highlightedCountry === null) {
		markerContainer.style('display', 'none');
		return;
	}

	var unit = getUnit();

	markerContainer.style('display', 'inline');

	markerContainer.select('.WorldMap-stackedbar-name')
		.text(State.highlightedCountry + ':');

	markerContainer.select('.WorldMap-stackedbar-value')
		.text(numberFormat(Math.round(getValue(State.highlightedCountry))) + ' ' + unit);

	// Calculate the position
	var barData = _.filter(sorted, d => d.Country === State.highlightedCountry);
	var pos = barData[0].pos;
	var len = barData[0].length;
	markerContainer
		.select('.WorldMap-stackedbar-inner')
		.attr('transform', 'translate(' + (pos + len * 0.5) + ',0)');
}

function update() {
	updateTotal();

	// var series = getSeries();
	sorted = _.sortBy(Model.data, d => -getValue(d.Country));
	sorted = layout(sorted);

	colorScale.domain([sorted[0].value, sorted[sorted.length - 1].value]);

	var u = container
		.select('.WorldMap-stackedbar-bars')
		.selectAll('rect')
		.data(sorted, d => d.Country);

	u.enter()
		.append('rect')
		.attr('height', 10)
		.on('mouseover', d => {State.set('highlightedCountry', d.Country)})
		.on('mouseout', d => {State.set('highlightedCountry', null)})

		.merge(u)
		// .transition(transition)
		.attr('x', d => d.pos)
		.attr('width', d => d.length)
		.style('fill', d => colorScale(d.value));

	u.exit().remove();
}


var api = {
	init: init
};

export default api;


/** WEBPACK FOOTER **
 ** ./src/StackedBar/StackedBar.js
 **/